<template>
  <div class="ui grid">
    <div class="row">
      <h1 class="ui huge header">Student selection</h1>
    </div>
    <div class="ui divider"></div>
    <div class="row">
      <sui-button primary content="How to create & save a class list" icon="question circle"
        v-on:click="openGallery(4)" />
      <!-- <sui-button primary content="How to upload a class list" icon="question circle" v-on:click="openGallery(5)" /> -->
    </div>
    <div class="row">
      <div class="ui ordered steps">
        <div class="completed step">
          <div class="content">
            <div class="title">Class selection</div>
            <div class="description">
              <router-link to="/class/select">Selected class: {{ selectedClass.name }}</router-link>
            </div>
          </div>
        </div>
        <div class="active step">
          <div class="content">
            <div class="title">Student selection</div>
            <div class="description">
              Check the list of Students and make changes if required
            </div>
          </div>
        </div>
        <div class="step">
          <div class="content">
            <div class="title">Confirm</div>
            <div class="description">Verify and Proceed</div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui divider"></div>
    <div class="row">
      <div class="ui segment" style="width:100%; padding: 0px;">
        <h4 class="ui header">Add students</h4>
        <form class="ui form" @submit.prevent="submitNewStudents">
          <div class="fields" v-for="(student, idx) in newStudents" :key="idx">
            <input type="hidden" v-model="student.id" />
            <div class="four wide field">
              <input type="text" placeholder="First Name" v-model="student.firstName" required />
            </div>
            <div class="four wide field">
              <input type="text" placeholder="Last Name" v-model="student.lastName" required />
            </div>
            <div class="four wide field">
              <input type="text" placeholder="Initials" v-model="student.initials"
                @keydown.tab.exact="addStudentRowTab(idx)" required />
            </div>
            <div class="two wide field">
              <button type="button" class="ui icon button" @click="removeStudentRow(idx)" v-if="newStudents.length > 1"
                title="Remove row">
                <i class="minus icon"></i>
              </button>
            </div>
          </div>
          <div class="row">
            <button type="button" class="ui button" @click="addStudentRow">
              <i class="plus icon"></i> Add Student
            </button>
            <button type="button" class="ui button" @click="saveStudents" :disabled="!canSubmitNewStudents">
              <i class="check icon"></i> Save class
            </button>
          </div>
          <div class="row" style="padding-top: 10px; border: 1;">
            <student-import v-on:imported="importStudents" ref="importStudents" />
          </div>
          <div class="row" style="margin-top: 10px;">
            <router-link to="/class/select">
              <sui-button content="Back to class selection" negative icon="arrow circle left" />
            </router-link>
            <button type="submit" class="ui positive button" :disabled="!canSubmitNewStudents">
              <i class="thumbs up icon"></i> Proceed to confirmation
            </button>
          </div>
        </form>
        <div class="row" v-if="!initialsAreUnique" style="margin-top: 10px;">
          <div class="ui warning message">
            <div class="header">
              Student initials must be unique
            </div>
            Please check the initials of the students to make sure they are unique.
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import StudentImport from '@/components/students/StudentImport';
import { mapGetters } from 'vuex';

export default {
  name: 'StudentSelecttion',
  components: { StudentImport },
  computed: {
    ...mapGetters({
      classStudents: 'classStudents',
      selectedClass: 'selectedClass',
    }),
  },
  data() {
    return {
      studentActions: ['update', 'remove'],
      initialsAreUnique: true,
      selectStudentActions: ['select'],
      newStudents: [
        { firstName: '', lastName: '', initials: '' },
      ],
    };
  },
  watch: {
    newStudents: {
      handler(newVal, oldVal) {
        this.newStudents.forEach((student, idx) => {
          if (student.firstName && student.lastName && !student.initials) {
            student.initials = (student.firstName.charAt(0) + student.lastName.charAt(0)).toUpperCase();
          }
        });
      },
      deep: true,
    },
  },
  methods: {
    openGallery(index) {
      this.$store.dispatch('showImage', { index });
    },
    rowAction(action) {
      if (action.action === 'remove') {
        this.$store.dispatch('removeStudentFromClass', action.id);
      }
      if (action.action === 'update') {
        this.$store.dispatch('showUpdateStudentModal', action.student);
      }
    },
    selectStudentAction(action) {
      if (action.action === 'select') {
        this.$store.dispatch('addStudentToClass', action.id);
      }
    },
    showCreateModal() {
      this.$store.dispatch('showAddStudentModal');
    },
    addStudentRow() {
      this.newStudents.push({ firstName: '', lastName: '', initials: '' });
    },
    addStudentRowTab(index) {
      if (index === this.newStudents.length - 1) {
        this.newStudents.push({ firstName: '', lastName: '', initials: '' });
      }
    },
    removeStudentRow(idx) {
      this.newStudents.splice(idx, 1);
    },
    submitNewStudents() {
      this.$store
        .dispatch('createClassStudents', { students: this.newStudents, classId: this.selectedClass.id })
        .then(
          () => {
            this.$router.push('/test/start');
          },
          () => { },
        );
    },
    saveStudents() {
      this.$store
        .dispatch('createClassStudents', { students: this.newStudents, classId: this.selectedClass.id });
    },
    importStudents() {
      this.$refs.importStudents.students.forEach((student) => {
        if (!student.initials) {
          student.initials = (student.firstName.charAt(0) + student.lastName.charAt(0)).toUpperCase();
        }
      });
      this.newStudents = [...this.newStudents, ...this.$refs.importStudents.students];
      this.newStudents = this.newStudents.filter(student => student.firstName || student.lastName || student.initials);
      this.newStudents.sort((a, b) => a.lastName.localeCompare(b.lastName));
      this.canSubmitNewStudents();
    },
  },
  computed: {
    ...mapGetters({
      classStudents: 'classStudents',
      selectedClass: 'selectedClass',
    }),
    canSubmitNewStudents() {
      // create a dictionary of initials of type <string, number>
      const initialsDict = {};
      this.newStudents.forEach((student) => {
        if (student.initials) {
          const initials = student.initials.toUpperCase();
          if (initialsDict[initials]) {
            student.initials = `${initials}${initialsDict[initials]}`;
            initialsDict[initials] += 1;
          } else {
            initialsDict[initials] = 1;
          }
        }
      });

      return this.newStudents.every(s => s.firstName && s.lastName && s.initials);
    }
  },
  created() {
    this.$store.dispatch('getClassStudents', this.selectedClass).then(
      (response) => {
        if (response.data && response.data.length > 0) {
          this.newStudents = response.data.map(student => ({
            id: student.id,
            firstName: student.firstName,
            lastName: student.lastName,
            initials: student.initials,
          }));
        } else {
          this.newStudents = [{ firstName: '', lastName: '', initials: '' }];
        }
      },
      (error) => {
      },
    );
  },
};
</script>
w


// WEBPACK FOOTER //
// src/components/students/StudentSelection.vue